/* BG IMAGES */
import BgAboutApplia from "../../assets/images/content/introduction/about-applia/bg-header.webp";
import BgAcceleratingEuropesGrowth from "../../assets/images/content/pillar-2/index/bg-header.webp";
import BgAdvancingSustainableLifestyles from "../../assets/images/content/pillar-1/index/bg-header.webp";
import BgAppliaSecretariat from "../../assets/images/content/introduction/applia-secretariat/bg-header.webp";
import BgBecomeAMember from "../../assets/images/content/introduction/become-a-member/bg-header.webp";
import BgDirectMembers from "../../assets/images/content/introduction/direct-members/bg-header.webp";
import BgHomeApplianceIndustry from "../../assets/images/content/introduction/the-home-appliance-industry-in-europe/bg-header.webp";
import BgForeword from "../../assets/images/content/introduction/foreword/bg-header.webp";
import BgIrhma from "../../assets/images/content/introduction/irhma/bg-header.webp";
import BgNationalAssociations from "../../assets/images/content/introduction/national-associations/bg-header.webp";
import BgPolicyDevelopments from "../../assets/images/content/introduction/policy-developments-in-2024/bg-header.webp";
import BgProjects from "../../assets/images/content/introduction/projects/bg-header.webp";
import BgProducts from "../../assets/images/content/introduction/products/bg-header.webp";
import BgRoadmap from "../../assets/images/content/introduction/roadmap-to-a-fair-sustainable-and-prosperous-european-society/bg-header.webp";
import BgWhatToExpect from "../../assets/images/content/introduction/what-to-watch-in-2025/bg-header.webp";

/* OTHER IMAGES */
import AboutApplia from "../../assets/images/content/introduction/about-applia/about-applia-mobile.svg";
import AverageMaterialCompositionOfHomeAppliancesVisual from "../../assets/images/content/pillar-1/average-material-composition-of-home-appliances/average-material-composition-of-home-appliances-visual.webp";
import ConsumerPillar2 from "../../assets/images/content/pillar-2/index/consumer.webp";
import Ecommerce from "../../assets/images/content/introduction/what-to-watch-in-2025/ecommerce.webp";
import GuidingPrinciples from "../../assets/images/content/introduction/what-to-watch-in-2025/guiding-principles-of-the-new-commission.svg";
import HakanBulgurLu from "../../assets/images/content/introduction/foreword/hakan_bulgurlu.jpg";
import HoardingOfWeeeVisual from "../../assets/vectors/content/pillar-1/hoarding-of-weee/Hoarding of WEEE.svg";
import PaoloFalcioni from "../../assets/images/content/introduction/foreword/paolo_falcioni.jpg";
import Policy1 from "../../assets/images/content/introduction/policy-developments-in-2024/europe.webp";
import Policy2 from "../../assets/images/content/introduction/policy-developments-in-2024/sustainability.webp";
import Policy3 from "../../assets/images/content/introduction/policy-developments-in-2024/discardedappliances.webp";
import Policy4 from "../../assets/images/content/introduction/policy-developments-in-2024/business.webp";
import Policy5 from "../../assets/images/content/introduction/policy-developments-in-2024/batteries.webp";
import Policy6 from "../../assets/images/content/introduction/policy-developments-in-2024/consumers.webp";
import Policy7 from "../../assets/images/content/introduction/policy-developments-in-2024/buildings.webp";
import Policy8 from "../../assets/images/content/introduction/policy-developments-in-2024/factory.webp";
import Project1 from "../../assets/images/content/introduction/projects/circular-plastics-alliance.webp";
import Project2 from "../../assets/images/content/introduction/projects/ecosweee.webp";
import Project3 from "../../assets/images/content/introduction/projects/i4r.webp";
import Project4 from "../../assets/images/content/introduction/projects/increace.webp";
import Project5 from "../../assets/images/content/introduction/projects/primus.webp";
import Project6 from "../../assets/images/content/introduction/projects/futuram.webp";
import QuantitiesOfIndividualMaterialsUsedInHomeAppliances from "../../assets/images/content/pillar-1/quantities-of-individual-materials-used-in-home-appliances/quantities-of-materials-used.svg";
import RepairPillar1 from "../../assets/images/content/pillar-1/index/repair.webp";
import Sink from "../../assets/images/content/introduction/what-to-watch-in-2025/sink.webp";
import TradePillar2 from "../../assets/images/content/pillar-2/index/trade.webp";

/* COMPONENT IMPORTS */
import { ContentBlock } from "../../components/ContentBuilder/ContentBuilder.type";

// Introduction custom components
import { AppliaSecretariat } from "../../components/CustomPageBlocks/introduction/AppliaSecretariat/AppliaSecretariat";
import { AppliaSecretariatHeader } from "../../components/CustomPageBlocks/introduction/AppliaSecretariat/AppliaSecretariatHeader";
import { BecomeAMember } from "../../components/CustomPageBlocks/introduction/BecomeAMember/BecomeAMember";
import { IRHMA } from "../../components/CustomPageBlocks/introduction/IRHMA/IRHMA";
import { NationalAssociations } from "../../components/CustomPageBlocks/introduction/NationalAssociations/NationalAssociations";
import { Roadmap } from "../../components/CustomPageBlocks/introduction/Roadmap/Roadmap";
import { RoadmapButton } from "../../components/CustomPageBlocks/introduction/Roadmap/RoadmapButton";
import { MemberButton } from "../../components/CustomPageBlocks/introduction/BecomeAMember/MemberButton";

// Introduction data files
import { AppliaSecretariatMembersTeam1 } from "../../assets/data/content/introduction/applia-secretariat/data1";
import { AppliaSecretariatMembersTeam2 } from "../../assets/data/content/introduction/applia-secretariat/data2";
import { AppliaSecretariatMembersTeam3 } from "../../assets/data/content/introduction/applia-secretariat/data3";
import { AppliaSecretariatMembersTeam4 } from "../../assets/data/content/introduction/applia-secretariat/data4";
import { AppliaSecretariatMembersTeam5 } from "../../assets/data/content/introduction/applia-secretariat/data5";
import { AppliaSecretariatMembersTeam6 } from "../../assets/data/content/introduction/applia-secretariat/data6";
import { directMembers } from "../../assets/data/content/introduction/direct-members/data";
import { IRHMAImages } from "../../assets/data/content/introduction/irhma/data";
import { repairImages } from "../../assets/data/content/pillar-1/repair-of-home-appliances/data"

// Pillar 1 custom components
import { AverageAnnualAdditionalSavings } from "../../components/CustomPageBlocks/pillar1/AverageAnnualAdditionalSavings/AverageAnnualAdditionalSavings";
import { AverageEnergyConsumptionDishwashers } from "../../components/CustomPageBlocks/pillar1/AverageEnergyConsumption/AverageEnergyConsumptionDishwashers";
import { AverageEnergyConsumptionWashingMachines } from "../../components/CustomPageBlocks/pillar1/AverageEnergyConsumption/AverageEnergyConsumptionWashingMachines";
import { AverageWaterConsumptionDishwashers } from "../../components/CustomPageBlocks/pillar1/AverageWaterConsumption/AverageWaterConsumptionDishwashers";
import { AverageWaterConsumptionWashingMachines } from "../../components/CustomPageBlocks/pillar1/AverageWaterConsumption/AverageWaterConsumptionWashingMachines";
import { AvgMaterialCompositionLargeHomeAppliances } from "../../components/CustomPageBlocks/pillar1/AvgMaterialCompositionLargeHomeAppliances/AvgMaterialCompositionLargeHomeAppliances";
import { AvgMaterialCompositionSmallHomeAppliances } from "../../components/CustomPageBlocks/pillar1/AvgMaterialCompositionSmallHomeAppliances/AvgMaterialCompositionSmallHomeAppliances";
import { CollectionOfWEEEByEUMemberStates } from "../../components/CustomPageBlocks/pillar1/CollectionOfWEEEByEUMemberStates/CollectionOfWEEEByEUMemberStates";
import { EnergyConsumptionAndEnergyPricesInTheEU } from "../../components/CustomPageBlocks/pillar1/EnergyConsumptionAndEnergyPricesInTheEU/EnergyConsumptionAndEnergyPricesInTheEU";
import { EvolutionOfEnergyConsumptionAndEnergyPrices } from "../../components/CustomPageBlocks/pillar1/EvolutionOfEnergyConsumptionAndEnergyPrices/EvolutionOfEnergyConsumptionAndEnergyPrices";
import { EvolutionOfEnergyBarchart } from "../../components/CustomPageBlocks/pillar1/EvolutionOfEnergyConsumptionAndEnergyPrices/EvolutionOfEnergyBarchart";
import { HomeApplianceIndustryInEurope } from "../../components/CustomPageBlocks/introduction/HomeApplianceIndustryInEurope/HomeApplianceIndustryInEurope";
import { MaterialsRecoveredFromWaste } from "../../components/CustomPageBlocks/pillar1/MaterialsRecoveredFromWaste/MaterialsRecoveredFromWaste";
import { MaterialUseDuringTheProductionProcess } from "../../components/CustomPageBlocks/pillar1/MaterialUseDuringTheProductionProcess/MaterialUseDuringTheProductionProcess";
import { Products } from "../../components/CustomPageBlocks/introduction/Products/Products";
import { RepairOfHomeAppliances } from "../../components/CustomPageBlocks/pillar1/RepairOfHomeAppliances/RepairOfHomeAppliances";
import { RoutesOfRecycledPlastic } from "../../components/CustomPageBlocks/pillar1/RoutesOfRecycledPlastic/RoutesOfRecycledPlastic";
import { WeeeFlowInTheHomeApplianceSector } from "../../components/CustomPageBlocks/pillar1/WeeeFlowInTheHomeApplianceSector/WeeeFlowInTheHomeApplianceSector";

// Pillar 1 data files
import AverageEnergyConsumptionDishwashersData from "../../assets/data/content/pillar-1/average-energy-consumption-dishwashers/data.json";
import AverageEnergyConsumptionWashingMachinesData from "../../assets/data/content/pillar-1/average-energy-consumption-washing-machines/data.json";
import AverageWaterConsumptionDishwashersData from "../../assets/data/content/pillar-1/average-water-consumption-dishwashers/data.json";
import AverageWaterConsumptionWashingMachinesData from "../../assets/data/content/pillar-1/average-water-consumption-washing-machines/data.json";
import AvgMaterialCompositionLargeHomeAppliancesData from "../../assets/data/content/pillar-1/avg-material-composition-large-home-appliances/data.json";
import AvgMaterialCompositionSmallHomeAppliancesData from "../../assets/data/content/pillar-1/avg-material-composition-small-home-appliances/data.json";
import CollectionOfWEEEByEUMemberStatesData from "../../assets/data/content/pillar-1/collection-of-weee-by-eu-member-states/data.json"
import EvolutionOfEnergyConsumptionAndEnergyPricesLineChartData from "../../assets/data/content/pillar-1/evolution-of-energy-consumption-and-energy-prices/line-chart-data.json";
import WeeeFlowInTheHomeApplianceSectorLineChartData from "../../assets/data/content/pillar-1/weee-flow-in-the-home-appliance-sector/line-chart-data.json";

// Pillar 2 custom components
import { MembersManufacturingSites } from "../../components/CustomPageBlocks/pillar2/MembersManufacturingSites/MembersManufacturingSites";
import { EuropeanMarketHistoricalPicture } from "../../components/CustomPageBlocks/pillar2/EuropeanMarketHistoricalPicture/EuropeanMarketHistoricalPicture";
import { EvolutionOfImportAndExportOfHomeAppliancesInEurope } from "../../components/CustomPageBlocks/pillar2/EvolutionOfImportAndExportOfHomeAppliancesInEurope/EvolutionOfImportAndExportOfHomeAppliancesInEurope";
import { Top10ImportAndExportCountries } from "../../components/CustomPageBlocks/pillar2/Top10ImportAndExportCountries/Top10ImportAndExportCountries";
import { ImportAndExportOfHomeAppliancesInEuropeByContinent } from "../../components/CustomPageBlocks/pillar2/ImportAndExportOfHomeAppliancesInEuropeByContinent/ImportAndExportOfHomeAppliancesInEuropeByContinent";
import { InvestmentInRAndDByEuMemberStates } from "../../components/CustomPageBlocks/pillar2/InvestmentInRAndDByEuMemberStates/InvestmentInRAndDByEuMemberStates";
import { InvestmentRDvsGDP } from "../../components/CustomPageBlocks/pillar2/InvestmentRDvsGDP/InvestmentRDvsGDP";
import { LargeAppliancesSoldGlobally } from "../../components/CustomPageBlocks/pillar2/LargeAppliancesSoldGlobally/LargeAppliancesSoldGlobally";
import { PatentsFiledAndGrantedForHomeAppliances } from "../../components/CustomPageBlocks/pillar2/PatentsFiledAndGrantedForHomeAppliances/PatentsFiledAndGrantedForHomeAppliances";
import { UnitsTradedInEuropeIntro } from "../../components/CustomPageBlocks/pillar2/UnitsTradedInEurope/UnitsTradedInEuropeIntro";
import { UnitsTradedInEuropeSection1 } from "../../components/CustomPageBlocks/pillar2/UnitsTradedInEurope/UnitsTradedInEuropeSection1";
import { UnitsTradedInEuropeSection2 } from "../../components/CustomPageBlocks/pillar2/UnitsTradedInEurope/UnitsTradedInEuropeSection2";

// Pillar 2 data files
import EuropeanMarketHistoricalPictureData from "../../assets/data/content/pillar-2/european-market-historical-picture/data.json";
import InvestmentRDvsGDPData from "../../assets/data/content/pillar-2/investment-rd-vs-gdp/data.json";
import PatentsFiledAndGrantedForHomeAppliancesData from "../../assets/data/content/pillar-2/patents-filed-and-granted-for-home-appliances/data.json";

// Special data files from DB
import { fetchTradeData } from "../../utils/fetchTradeData";
import { fetchCountryData } from "../../utils/fetchCountryData";

export interface PageContentSource {
	label: string;
	url?: string;
}

export interface PagePdf {
	path: string;
	filename?: string;
}

export interface PageContent {
	heroIntro?: string;
	heroImage?: string;
	pageIntro?: string;
	blocks: ContentBlock[];
	source?: PageContentSource | Array<Required<PageContentSource>>;
	pdf?: PagePdf;
}

export const pageContent: { [key: string]: PageContent } = {
	"navigation.introduction.aboutApplia": {
		heroImage: BgAboutApplia,
		heroIntro: "pages.introduction.aboutApplia.heroIntro",
		blocks: [
			{
				id: "aboutApplia-intro",
				type: "text-image",
				data: {
					text: [
						"pages.introduction.aboutApplia.blocks.intro.paragraph1",
						"pages.introduction.aboutApplia.blocks.intro.paragraph2",
						"pages.introduction.aboutApplia.blocks.intro.paragraph3"
					],
					type: "image-right",
					imageAlt: "pages.introduction.foreword.blocks.hakanBulgurlu.imageAlt",
					imageUrl: AboutApplia,
					imageSize: "big",
				},
			},
		],
	},
	"navigation.introduction.foreword": {
		heroImage: BgForeword,
		heroIntro: "pages.introduction.foreword.heroIntro",
		blocks: [
			{ 
				type: "text",
				id: "foreword-spacer0",
				data: {
					text: "pages.introduction.foreword.blocks.spacer1.paragraph1"
				}
			},
			{
				type: "text-image",
				id: "foreword-hakan-bulgurlu",
				data: {
					text: ["pages.introduction.foreword.blocks.hakanBulgurlu.paragraph1", "pages.introduction.foreword.blocks.hakanBulgurlu.paragraph2", "pages.introduction.foreword.blocks.hakanBulgurlu.paragraph3"],
					title: "pages.introduction.foreword.blocks.hakanBulgurlu.title",
					type: "image-left",
					imageAlt: "pages.introduction.foreword.blocks.hakanBulgurlu.imageAlt",
					imageUrl: HakanBulgurLu,
					imageSize: "small",
				},
			},
			{ 
				type: "text",
				id: "foreword-spacer1",
				data: {
					text: "pages.introduction.foreword.blocks.spacer1.paragraph1"
				}
			},
			{
				type: "text-image",
				id: "foreword-paolo-falcioni",
				data: {
					text: ["pages.introduction.foreword.blocks.paoloFalcioni.paragraph1", "pages.introduction.foreword.blocks.paoloFalcioni.paragraph2", "pages.introduction.foreword.blocks.paoloFalcioni.paragraph3"],
					title: "pages.introduction.foreword.blocks.paoloFalcioni.title",
					type: "image-left",
					imageAlt: "pages.introduction.foreword.blocks.paoloFalcioni.imageAlt",
					imageUrl: PaoloFalcioni,
					imageSize: "small",
				},
			},
		],
	},
	"navigation.introduction.appliaDirectMembers": {
		heroImage: BgDirectMembers,
		heroIntro: "pages.introduction.appliaDirectMembers.heroIntro",
		blocks: [
			{
				id: "applia-direct-members-intro",
				type: "text",
				data: {
					text: [
						"pages.introduction.appliaDirectMembers.blocks.intro.paragraph1",
						"pages.introduction.appliaDirectMembers.blocks.intro.paragraph2",
					],
				},
			},
			{
				id: "applia-direct-members-grid",
				type: "image-grid",
				data: {
					cols: 2,
					responsiveCols: {
						xs: 3,
						md: 4,
					},
					items: directMembers,
				},
			},
		],
	},
	"navigation.introduction.becomeAMember": {
		heroImage: BgBecomeAMember,
		blocks: [
			{
				id: "pages.introduction.becomeAMember.blocks.data",
				type: "custom",
				data: {
					component: BecomeAMember,
				},
			},
			{
				type: "custom",
				id: "pages.introduction.becomeAMember.blocks.button",
				data: {
					component: MemberButton,
				},
			},
		],
	},
	"navigation.introduction.nationalAssociations": {
		heroImage: BgNationalAssociations,
		heroIntro: "pages.introduction.nationalAssociations.heroIntro",
		blocks: [
			{
				type: "custom",
				id: "pages.introduction.nationalAssociations.map",
				data: {
					component: NationalAssociations,
				},
			},
		],
	},
	"navigation.introduction.irhma": {
		heroImage: BgIrhma,
		blocks: [
			{
				id: "pages.introduction.irhma.blocks.introduction",
				type: "text",
				data: {
					text: ["pages.introduction.irhma.blocks.introduction.paragraph1", "pages.introduction.irhma.blocks.introduction.paragraph2", "pages.introduction.irhma.blocks.introduction.paragraph3"],
				}
			},
			{
				type: "custom",
				id: "pages.introduction.irhma.blocks.map",
				data: {
					component: IRHMA,
				},
			},
			{
				type: "image-grid",
				id: "pages.introduction.irhma.blocks.images",
				data: {
					cols: 3,
					responsiveCols: {
						xs: 1,
						md: 3,
					},
					items: IRHMAImages,
				},
			},
		],
	},
	"navigation.introduction.appliaSecretariat": {
		heroImage: BgAppliaSecretariat,
		blocks: [
			{
				id: "navigation-introduction-appliaSecretariat-header",
				type: "custom",
				data: {
					component: AppliaSecretariatHeader,
				},
			},
			{
				id: "navigation-introduction-appliaSecretariat-team1",
				type: "custom",
				data: {
					component: AppliaSecretariat,
					props: {
						members: AppliaSecretariatMembersTeam1,
					},
				},
			},
			{
				id: "navigation-introduction-appliaSecretariat-team2",
				type: "custom",
				data: {
					component: AppliaSecretariat,
					props: {
						members: AppliaSecretariatMembersTeam2,
					},
				},
			},
			{
				id: "navigation-introduction-appliaSecretariat-team3",
				type: "custom",
				data: {
					component: AppliaSecretariat,
					props: {
						members: AppliaSecretariatMembersTeam3,
					},
				},
			},
			{
				id: "navigation-introduction-appliaSecretariat-team4",
				type: "custom",
				data: {
					component: AppliaSecretariat,
					props: {
						members: AppliaSecretariatMembersTeam4,
					},
				},
			},
			{
				id: "navigation-introduction-appliaSecretariat-team5",
				type: "custom",
				data: {
					component: AppliaSecretariat,
					props: {
						members: AppliaSecretariatMembersTeam5,
					},
				},
			},
			{
				id: "navigation-introduction-appliaSecretariat-team6",
				type: "custom",
				data: {
					component: AppliaSecretariat,
					props: {
						members: AppliaSecretariatMembersTeam6,
					},
				},
			},
		],
	},
	"navigation.introduction.homeApplianceIndustryInEurope": {
		heroImage: BgHomeApplianceIndustry,
		blocks: [
			{
				id: "pages.introduction.homeApplianceIndustryInEurope.blocks.data",
				type: "custom",
				data: {
					component: HomeApplianceIndustryInEurope,
				},
			},
		],
	},
	"navigation.introduction.products": {
		heroIntro: "pages.introduction.products.pageIntro",
		heroImage: BgProducts,
		blocks: [
			{
				type: "custom",
				id: "pages.introduction.products.blocks.visual",
				data: {
					component: Products,
				},
			},
		],
	},
	"navigation.introduction.projects": {
		heroImage: BgProjects,
		blocks: [
			{
				type: "text-image",
				id: "project1",
				data: {
					text: ["pages.introduction.projects.blocks.project1.paragraph"],
					type: "image-left",
					imageAlt: "pages.introduction.projects.blocks.project1.imageAlt",
					imageUrl: Project1,
					imageSize: "small",
				},
			},
			{
				type: "text-image",
				id: "project2",
				data: {
					text: ["pages.introduction.projects.blocks.project2.paragraph"],
					type: "image-left",
					imageAlt: "pages.introduction.projects.blocks.project1.imageAlt",
					imageUrl: Project2,
					imageSize: "small",
				},
			},
			{
				type: "text-image",
				id: "project3",
				data: {
					text: ["pages.introduction.projects.blocks.project3.paragraph"],
					type: "image-left",
					imageAlt: "pages.introduction.projects.blocks.project1.imageAlt",
					imageUrl: Project3,
					imageSize: "small",
				},
			},
			{
				type: "text-image",
				id: "project4",
				data: {
					text: ["pages.introduction.projects.blocks.project4.paragraph"],
					type: "image-left",
					imageAlt: "pages.introduction.projects.blocks.project1.imageAlt",
					imageUrl: Project4,
					imageSize: "small",
				},
			},
			{
				type: "text-image",
				id: "project5",
				data: {
					text: ["pages.introduction.projects.blocks.project5.paragraph"],
					type: "image-left",
					imageAlt: "pages.introduction.projects.blocks.project1.imageAlt",
					imageUrl: Project5,
					imageSize: "small",
				},
			},
			{
				type: "text-image",
				id: "project6",
				data: {
					text: ["pages.introduction.projects.blocks.project6.paragraph"],
					type: "image-left",
					imageAlt: "pages.introduction.projects.blocks.project1.imageAlt",
					imageUrl: Project6,
					imageSize: "small",
				},
			},
		],
	},
	"navigation.introduction.policyDevelopmentsIn2024": {
		heroImage: BgPolicyDevelopments,
		blocks: [
			{
				id: "pages.introduction.policyDevelopmentsIn2024.blocks.introduction",
				type: "text",
				data: {
					text: ["pages.introduction.policyDevelopmentsIn2024.blocks.introduction.paragraph1", "pages.introduction.policyDevelopmentsIn2024.blocks.introduction.paragraph2"],
				}
			},
			{
				id: "pages.introduction.policyDevelopmentsIn2024.blocks.introduction2",
				type: "text-image",
				data: {
					imageSize: "normal",
					type: "image-left",
					imageUrl: Policy1,
					text: [
						"pages.introduction.policyDevelopmentsIn2024.blocks.introduction2.paragraph1",
						"pages.introduction.policyDevelopmentsIn2024.blocks.introduction2.paragraph2"
					],
				},
			},
			{
				id: "pages.introduction.policyDevelopmentsIn2024.blocks.sustainability",
				type: "header",
				data: {
					text: "pages.introduction.policyDevelopmentsIn2024.blocks.sustainability.title",
					type: "h2",
				},
			},
			{
				id: "pages.introduction.policyDevelopmentsIn2024.blocks.sustainability-text-image",
				type: "text-image",
				data: {
					imageSize: "normal",
					type: "image-right",
					imageUrl: Policy2,
					title: "pages.introduction.policyDevelopmentsIn2024.blocks.sustainability.espr.title",
					text: [
						"pages.introduction.policyDevelopmentsIn2024.blocks.sustainability.espr.paragraph"
					],
				},
			},
			{
				id: "pages.introduction.policyDevelopmentsIn2024.blocks.weee-text-image",
				type: "text-image",
				data: {
					imageSize: "normal",
					type: "image-left",
					imageUrl: Policy3,
					title: "pages.introduction.policyDevelopmentsIn2024.blocks.sustainability.weee.title",
					text: [
						"pages.introduction.policyDevelopmentsIn2024.blocks.sustainability.weee.paragraph1",
						"pages.introduction.policyDevelopmentsIn2024.blocks.sustainability.weee.paragraph2"
					],
				},
			},
			{
				id: "pages.introduction.policyDevelopmentsIn2024.blocks.sustainability.fgas",
				type: "text",
				data: {
					title: "pages.introduction.policyDevelopmentsIn2024.blocks.sustainability.fgas.title",
					text: [
						"pages.introduction.policyDevelopmentsIn2024.blocks.sustainability.fgas.paragraph1",
						"pages.introduction.policyDevelopmentsIn2024.blocks.sustainability.fgas.paragraph2"
					],
				},
			},
			{
				id: "pages.introduction.policyDevelopmentsIn2024.blocks.sustainability.greendeal",
				type: "text-image",
				data: {
					imageSize: "normal",
					type: "image-left",
					imageUrl: Policy4,
					title: "pages.introduction.policyDevelopmentsIn2024.blocks.sustainability.greendeal.title",
					text: [
						"pages.introduction.policyDevelopmentsIn2024.blocks.sustainability.greendeal.paragraph1",
						"pages.introduction.policyDevelopmentsIn2024.blocks.sustainability.greendeal.paragraph2",
						"pages.introduction.policyDevelopmentsIn2024.blocks.sustainability.greendeal.paragraph3",
					],
				},
			},
			{
				id: "pages.introduction.policyDevelopmentsIn2024.blocks.sustainability.greenclaims",
				type: "text",
				data: {
					title: "pages.introduction.policyDevelopmentsIn2024.blocks.sustainability.greenclaims.title",
					text: [
						"pages.introduction.policyDevelopmentsIn2024.blocks.sustainability.greenclaims.paragraph"
					],
				},
			},
			{
				id: "pages.introduction.policyDevelopmentsIn2024.blocks.sustainability.ppwr",
				type: "text",
				data: {
					title: "pages.introduction.policyDevelopmentsIn2024.blocks.sustainability.ppwr.title",
					text: [
						"pages.introduction.policyDevelopmentsIn2024.blocks.sustainability.ppwr.paragraph"
					],
				},
			},
			{
				id: "pages.introduction.policyDevelopmentsIn2024.blocks.sustainability.batteries",
				type: "text-image",
				data: {
					imageSize: "normal",
					type: "image-right",
					imageUrl: Policy5,
					title: "pages.introduction.policyDevelopmentsIn2024.blocks.sustainability.batteries.title",
					text: [
						"pages.introduction.policyDevelopmentsIn2024.blocks.sustainability.batteries.paragraph1",
						"pages.introduction.policyDevelopmentsIn2024.blocks.sustainability.batteries.paragraph2",
						"pages.introduction.policyDevelopmentsIn2024.blocks.sustainability.batteries.paragraph3",
					],
				},
			},
			{
				id: "pages.introduction.policyDevelopmentsIn2024.blocks.corporate",
				type: "header",
				data: {
					text: "pages.introduction.policyDevelopmentsIn2024.blocks.corporate.title",
					type: "h2",
				},
			},
			{
				id: "pages.introduction.policyDevelopmentsIn2024.blocks.corporate.due-diligence",
				type: "text",
				data: {
					title: "pages.introduction.policyDevelopmentsIn2024.blocks.corporate.due-diligence.title",
					text: "pages.introduction.policyDevelopmentsIn2024.blocks.corporate.due-diligence.paragraph",
				},
			},
			{
				id: "pages.introduction.policyDevelopmentsIn2024.blocks.corporate.empowering",
				type: "text-image",
				data: {
					imageUrl: Policy6,
					imageSize: "normal",
					type: "image-left",
					title: "pages.introduction.policyDevelopmentsIn2024.blocks.corporate.empowering.title",
					text: [
						"pages.introduction.policyDevelopmentsIn2024.blocks.corporate.empowering.paragraph1",
						"pages.introduction.policyDevelopmentsIn2024.blocks.corporate.empowering.paragraph2",
					],
				},
			},
			{
				id: "pages.introduction.policyDevelopmentsIn2024.blocks.corporate.rightToRepair",
				type: "text",
				data: {
					title: "pages.introduction.policyDevelopmentsIn2024.blocks.corporate.rightToRepair.title",
					text: ["pages.introduction.policyDevelopmentsIn2024.blocks.corporate.rightToRepair.paragraph1","pages.introduction.policyDevelopmentsIn2024.blocks.corporate.rightToRepair.paragraph2","pages.introduction.policyDevelopmentsIn2024.blocks.corporate.rightToRepair.paragraph3","pages.introduction.policyDevelopmentsIn2024.blocks.corporate.rightToRepair.paragraph4"],
				},
			},
			{
				id: "pages.introduction.policyDevelopmentsIn2024.blocks.energy",
				type: "header",
				data: {
					text: "pages.introduction.policyDevelopmentsIn2024.blocks.energy.title",
					type: "h2",
				},
			},
			{
				id: "pages.introduction.policyDevelopmentsIn2024.blocks.energy.water",
				type: "text",
				data: {
					title: "pages.introduction.policyDevelopmentsIn2024.blocks.energy.water.title",
					text: "pages.introduction.policyDevelopmentsIn2024.blocks.energy.water.paragraph",
				},
			},
			{
				id: "pages.introduction.policyDevelopmentsIn2024.blocks.energy.buildings",
				type: "text-image",
				data: {
					imageSize: "normal",
					imageUrl: Policy7,
					type: "image-left",
					title: "pages.introduction.policyDevelopmentsIn2024.blocks.energy.buildings.title",
					text: "pages.introduction.policyDevelopmentsIn2024.blocks.energy.buildings.paragraph",
				},
			},
			{
				id: "pages.introduction.policyDevelopmentsIn2024.blocks.digitalisation-trade",
				type: "header",
				data: {
					text: "pages.introduction.policyDevelopmentsIn2024.blocks.digitalisation-trade.title",
					type: "h2",
				},
			},
			{
				id: "pages.introduction.policyDevelopmentsIn2024.blocks.digitalisation-trade.ai-act",
				type: "text",
				data: {
					title: "pages.introduction.policyDevelopmentsIn2024.blocks.digitalisation-trade.ai-act.title",
					text: "pages.introduction.policyDevelopmentsIn2024.blocks.digitalisation-trade.ai-act.paragraph",
				},
			},
			{
				id: "pages.introduction.policyDevelopmentsIn2024.blocks.digitalisation-trade.cbam-text-image",
				type: "text-image",
				data: {
					imageSize: "normal",
					imageUrl: Policy8,
					type: "image-right",
					title: "pages.introduction.policyDevelopmentsIn2024.blocks.digitalisation-trade.cbam.title",
					text: [
						"pages.introduction.policyDevelopmentsIn2024.blocks.digitalisation-trade.cbam.paragraph1",
						"pages.introduction.policyDevelopmentsIn2024.blocks.digitalisation-trade.cbam.paragraph2",
					],
				},
			},
			{
				id: "pages.introduction.policyDevelopmentsIn2024.blocks.digitalisation-trade.cyber-resilience",
				type: "text",
				data: {
					title: "pages.introduction.policyDevelopmentsIn2024.blocks.digitalisation-trade.cyber-resilience.title",
					text: "pages.introduction.policyDevelopmentsIn2024.blocks.digitalisation-trade.cyber-resilience.paragraph",
				},
			},
			{
				id: "pages.introduction.policyDevelopmentsIn2024.blocks.digitalisation-trade.data-act",
				type: "text",
				data: {
					title: "pages.introduction.policyDevelopmentsIn2024.blocks.digitalisation-trade.data-act.title",
					text: "pages.introduction.policyDevelopmentsIn2024.blocks.digitalisation-trade.data-act.paragraph",
				},
			},
			{
				id: "pages.introduction.policyDevelopmentsIn2024.blocks.digitalisation-trade.liability",
				type: "text",
				data: {
					title: "pages.introduction.policyDevelopmentsIn2024.blocks.digitalisation-trade.liability.title",
					text: "pages.introduction.policyDevelopmentsIn2024.blocks.digitalisation-trade.liability.paragraph",
				},
			}
		],
	},
	"navigation.introduction.roadmapToAFairSustainableAndProsperousEuropeanSociety": {
		heroImage: BgRoadmap,
		pageIntro: "pages.introduction.roadmapToAFairSustainableAndProsperousEuropeanSociety.pageIntro",
		blocks: [
			{
				type: "custom",
				id: "pages.introduction.roadmapToAFairSustainableAndProsperousEuropeanSociety.blocks.visual",
				data: {
					component: Roadmap,
				},
			},
			{
				type: "custom",
				id: "pages.introduction.roadmapToAFairSustainableAndProsperousEuropeanSociety.blocks.button",
				data: {
					component: RoadmapButton,
				},
			},
		]
	},
	"navigation.introduction.whatToWatchIn2025": {
		heroImage: BgWhatToExpect,
		blocks: [
			{
				id: "pages.introduction.whatToWatchIn2025.blocks.intro",
				type: "text",
				data: {
					text: "pages.introduction.whatToWatchIn2025.blocks.intro.paragraph",
				},
			},
			{
				id: "pages.introduction.whatToWatchIn2025.blocks.image",
				type: "image",
				data: {
					imageUrl: GuidingPrinciples,
					imageAlt: "pages.introduction.whatToWatchIn2025.blocks.visual.alt",
					imageSize: "big",
					imageAlignment: "center",
				},
			},
			{
				id: "pages.introduction.whatToWatchIn2025.blocks.presidency.title",
				type: "header",
				data: {
					text: "pages.introduction.whatToWatchIn2025.blocks.presidency.title",
					type: "h3"
				},
			},
			{
				id: "pages.introduction.whatToWatchIn2025.blocks.presidency",
				type: "text",
				data: {
					text: "pages.introduction.whatToWatchIn2025.blocks.presidency.paragraph",
				},
			},
			{
				id: "pages.introduction.whatToWatchIn2025.blocks.old.title",
				type: "header",
				data: {
					text: "pages.introduction.whatToWatchIn2025.blocks.old.title",
					type: "h3"
				},
			},
			{
				id: "pages.introduction.whatToWatchIn2025.blocks.old",
				type: "text",
				data: {
					text: "pages.introduction.whatToWatchIn2025.blocks.old.paragraph",
				},
			},
			{
				id: "pages.introduction.whatToWatchIn2025.blocks.new.title",
				type: "header",
				data: {
					text: "pages.introduction.whatToWatchIn2025.blocks.new.title",
					type: "h3"
				},
			},
			{
				id: "pages.introduction.whatToWatchIn2025.blocks.new1",
				type: "text",
				data: {
					text: "pages.introduction.whatToWatchIn2025.blocks.new.paragraph1",
				},
			},
			{
				id: "pages.introduction.whatToWatchIn2025.blocks.new2",
				type: "text-image",
				data: {
					imageSize: "normal",
					type: "image-left",
					imageUrl: Ecommerce,
					text: [
						"pages.introduction.whatToWatchIn2025.blocks.new.paragraph2",
						"pages.introduction.whatToWatchIn2025.blocks.new.paragraph3"
					],
				},
			},
			{
				id: "pages.introduction.whatToWatchIn2025.blocks.new3",
				type: "text",
				data: {
					text: [
						"pages.introduction.whatToWatchIn2025.blocks.new.paragraph4",
						"pages.introduction.whatToWatchIn2025.blocks.new.paragraph5",
						"pages.introduction.whatToWatchIn2025.blocks.new.paragraph6"
					]
				},
			},
			{
				id: "pages.introduction.whatToWatchIn2025.blocks.new4",
				type: "text-image",
				data: {
					imageSize: "normal",
					type: "image-right",
					imageUrl: Sink,
					text: [
						"pages.introduction.whatToWatchIn2025.blocks.new.paragraph7",
						"pages.introduction.whatToWatchIn2025.blocks.new.paragraph8",
						"pages.introduction.whatToWatchIn2025.blocks.new.paragraph9",
						"pages.introduction.whatToWatchIn2025.blocks.new.paragraph10",
						"pages.introduction.whatToWatchIn2025.blocks.new.paragraph11"
					],
				},
			},
		],
	},
	/* 📝 PILLAR 1 */
	"navigation.pillar1.index": {
		heroImage: BgAdvancingSustainableLifestyles,
		heroIntro: "pages.pillar.pillar1.index.heroIntro",
		blocks: [
			{
				type: "text",
				id: "pages.pillar.pillar1.index.blocks.intro",
				data: {
					text: [
						"pages.pillar.pillar1.index.blocks.intro.paragraph1",
						"pages.pillar.pillar1.index.blocks.intro.paragraph2",
						"pages.pillar.pillar1.index.blocks.intro.paragraph3",
					],
				},
			},
			{
				id: "pages.pillar.pillar1.index.blocks.repair",
				type: "text-image",
				data: {
					text: [
						"pages.pillar.pillar1.index.blocks.repair.paragraph1", 
						"pages.pillar.pillar1.index.blocks.repair.paragraph2",
						"pages.pillar.pillar1.index.blocks.repair.paragraph3",
						"pages.pillar.pillar1.index.blocks.repair.paragraph4"
					],
					type: "image-left",
					imageSize: "normal",
					imageUrl: RepairPillar1,
				},
			},
		],
	},
	"navigation.pillar1.materialUseDuringTheProductionProcess": {
		source: {
			label: "dss+",
		},
		pdf: {
			path: "/files/pdf/pillar-1/APPLiA-MaterialUseDuringTheProductionProcess.pdf",
			filename: "APPLiA - Material use during the production process",
		},
		blocks: [
			{
				id: "pages.pillar.pillar1.materialUseDuringTheProductionProcess.blocks.intro",
				type: "text",
				data: {
					text: "pages.pillar.pillar1.materialUseDuringTheProductionProcess.blocks.intro.paragraph1",
				},
			},
			{
				type: "custom",
				id: "pages.pillar.pillar1.materialUseDuringTheProductionProcess.blocks.visual",
				data: {
					component: MaterialUseDuringTheProductionProcess,
				},
			},
		],
	},
	"navigation.pillar1.averageWaterConsumption": {
		source: {
			label: "APPLiA members data",
		},
		pdf: {
			path: "/files/pdf/pillar-1/APPLiA-AverageWaterConsumptionOfWashingMachinesAndDishwashers.pdf",
			filename: "APPLiA - Average water consumption of washing machines and dishwashers",
		},
		blocks: [
			{
				id: "pages.pillar.pillar1.averageWaterConsumption.blocks.intro1",
				type: "text",
				data: {
					text: "pages.pillar.pillar1.averageWaterConsumption.blocks.intro1.paragraph1"
				},
			},
			{
				id: "pages.pillar.pillar1.averageWaterConsumption.blocks.chart-washing-machines",
				type: "custom",
				data: {
					component: AverageWaterConsumptionWashingMachines,
					props: {
						data: AverageWaterConsumptionWashingMachinesData,
					},
				},
			},
			{
				id: "pages.pillar.pillar1.averageWaterConsumption.blocks.intro2",
				type: "text",
				data: {
					text: "pages.pillar.pillar1.averageWaterConsumption.blocks.intro2.paragraph"
				},
			},
			{
				id: "pages.pillar.pillar1.averageWaterConsumption.blocks.chart-dishwashers",
				type: "custom",
				data: {
					component: AverageWaterConsumptionDishwashers,
					props: {
						data: AverageWaterConsumptionDishwashersData,
					},
				},
			},
		],
	},
	"navigation.pillar1.averageEnergyConsumption": {
		source: {
			label: "APPLiA members data",
		},
		pdf: {
			path: "/files/pdf/pillar-1/APPLiA-AverageEnergyConsumptionOfWashingMachinesAndDishwashers.pdf",
			filename: "APPLiA - Average energy consumption of washing machines and dishwashers",
		},
		blocks: [
			{
				id: "pages.pillar.pillar1.averageEnergyConsumption.blocks.intro1",
				type: "text",
				data: {
					text:	"pages.pillar.pillar1.averageEnergyConsumption.blocks.intro1.paragraph",
				},
			},
			{
				id: "pages.pillar.pillar1.averageEnergyConsumption.blocks.chart-washing-machines",
				type: "custom",
				data: {
					component: AverageEnergyConsumptionWashingMachines,
					props: {
						data: AverageEnergyConsumptionWashingMachinesData,
					},
				},
			},
			{
				id: "pages.pillar.pillar1.averageEnergyConsumption.blocks.intro2",
				type: "text",
				data: {
					text: "pages.pillar.pillar1.averageEnergyConsumption.blocks.intro2.paragraph",
				},
			},
			{
				id: "pages.pillar.pillar1.averageEnergyConsumption.blocks.chart-dishwashers",
				type: "custom",
				data: {
					component: AverageEnergyConsumptionDishwashers,
					props: {
						data: AverageEnergyConsumptionDishwashersData,
					},
				},
			},
		],
	},
	"navigation.pillar1.averageMaterialCompositionOfHomeAppliances": {
		source: {
			label: "dss+",
		},
		pdf: {
			path: "/files/pdf/pillar-1/APPLiA-AverageMaterialCompositionOfHomeAppliances.pdf",
			filename: "APPLiA - Average material composition of home appliances",
		},
		blocks: [
			{
				id: "pages.pillar.pillar1.averageMaterialCompositionOfHomeAppliances.blocks.intro",
				type: "text",
				data: {
					text: "pages.pillar.pillar1.averageMaterialCompositionOfHomeAppliances.blocks.intro.paragraph1",
				},
			},
			{
				type: "image",
				id: "pages.pillar.pillar1.averageMaterialCompositionOfHomeAppliances.blocks.visual",
				data: {
					imageUrl: AverageMaterialCompositionOfHomeAppliancesVisual,
					imageAlt: "pages.pillar.pillar1.averageMaterialCompositionOfHomeAppliances.blocks.visual.alt",
					imageSize: "normal",
					imageAlignment: "center",
				},
			},
		],
	},
	"navigation.pillar1.quantitiesOfIndividualMaterialsUsedInHomeAppliances": {
		source: {
			label: "dss+",
		},
		pdf: {
			path: "/files/pdf/pillar-1/APPLiA-QuantitiesOfIndividualMaterialsUsedInHomeAppliances.pdf",
			filename: "APPLiA - Quantities of individual materials used in home appliances",
		},
		blocks: [
			{
				type: "text",
				id: "pages.pillar.pillar1.quantitiesOfIndividualMaterialsUsedInHomeAppliances.blocks.intro",
				data: {
					text: "pages.pillar.pillar1.quantitiesOfIndividualMaterialsUsedInHomeAppliances.blocks.intro.paragraph"
				},
			},
			{
				type: "image",
				id: "pages.pillar.pillar1.quantitiesOfIndividualMaterialsUsedInHomeAppliances.blocks.visual",
				data: {
					imageUrl: QuantitiesOfIndividualMaterialsUsedInHomeAppliances,
					imageAlt: "pages.pillar.pillar1.quantitiesOfIndividualMaterialsUsedInHomeAppliances.blocks.visual.alt",
					imageSize: "big",
					imageAlignment: "center",
				},
			},
		],
	},
	"navigation.pillar1.averageMaterialCompositionOfLargeHomeAppliances": {
		source: {
			label: "dss+",
		},
		pdf: {
			path: "/files/pdf/pillar-1/APPLiA-AverageMaterialCompositionOfLargeHomeAppliances.pdf",
			filename: "APPLiA - Average material composistion of large home appliances",
		},
		blocks: [
			{
				type: "text",
				id: "pages.pillar.pillar1.averageMaterialCompositionOfLargeHomeAppliances.blocks.intro",
				data: {
					text: "pages.pillar.pillar1.averageMaterialCompositionOfLargeHomeAppliances.blocks.intro",
				},
			},
			{
				type: "custom",
				id: "pages.pillar.pillar1.averageMaterialCompositionOfLargeHomeAppliances",
				data: {
					component: AvgMaterialCompositionLargeHomeAppliances,
					props: {
						data: AvgMaterialCompositionLargeHomeAppliancesData,
					},
				},
			},
		],
	},
	"navigation.pillar1.averageMaterialCompositionOfSmallHomeAppliances": {
		source: {
			label: "dss+",
		},
		pdf: {
			path: "/files/pdf/pillar-1/APPLiA-AverageMaterialCompositionOfSmallHomeAppliances.pdf",
			filename: "APPLiA - Average material composistion of small home appliances",
		},
		blocks: [
			{
				type: "text",
				id: "pages.pillar.pillar1.averageMaterialCompositionOfSmallHomeAppliances.blocks.intro",
				data: {
					text: "pages.pillar.pillar1.averageMaterialCompositionOfSmallHomeAppliances.blocks.intro",
				},
			},
			{
				type: "custom",
				id: "pages.pillar.pillar1.averageMaterialCompositionOfSmallHomeAppliances.chart",
				data: {
					component: AvgMaterialCompositionSmallHomeAppliances,
					props: {
						data: AvgMaterialCompositionSmallHomeAppliancesData,
					},
				},
			},
		],
	},
	"navigation.pillar1.routesOfRecycledPlastic": {
		source: {
			label: "dss+",
		},
		pdf: {
			path: "/files/pdf/pillar-1/APPLiA-RoutesOfRecycledPlastic.pdf",
			filename: "APPLiA - Routes of recycled plastic",
		},
		blocks: [
			{
				type: "text",
				id: "pages.pillar.pillar1.routesOfRecycledPlastic.blocks.intro",
				data: {
					text: "pages.pillar.pillar1.routesOfRecycledPlastic.blocks.intro.paragraph",
				},
			},
			{
				type: "custom",
				id: "pages.pillar.pillar1.routesOfRecycledPlastic.blocks.visual",
				data: {
					component: RoutesOfRecycledPlastic,
				},
			},
		],
	},
	"navigation.pillar1.repairOfHomeAppliances": {
		source: {
			label: "dss+ calculations based on APPLiA members data",
		},
		pdf: {
			path: "/files/pdf/pillar-1/APPLiA-RepairOfHomeAppliances.pdf",
			filename: "APPLiA - Repair of home appliances",
		},
		blocks: [
			{
				type: "text",
				id: "pages.pillar.pillar1.repairOfHomeAppliances.blocks.intro",
				data: {
					text: "pages.pillar.pillar1.repairOfHomeAppliances.blocks.intro.paragraph",
				},
			},
			{
				type: "image-grid",
				id: "pages.pillar.pillar1.repairOfHomeAppliances.blocks.images",
				data: {
					cols: 4,
					responsiveCols: {
						xs: 2,
						md: 4,
						lg: 4,
					},
					items: repairImages,
				},
			},
			{
				type: "custom",
				id: "pages.pillar.pillar1.repairOfHomeAppliances.blocks.visual",
				data: {
					component: RepairOfHomeAppliances,
				},
			},
		],
	},
	"navigation.pillar1.evolutionOfEnergyConsumptionAndEnergyPrices": {
		source: {
			label: "B Lapillonne and Zineb Raji, Enerdata, Energy Efficiency Trends for Households in the EU, Odyssee MURE webinar, November 2024. www.odyssee-mure.eu/events/webinar",
		},
		pdf: {
			path: "/files/pdf/pillar-1/APPLiA-EvolutionOfEnergyConsumptionAndEnergyPrices.pdf",
			filename: "APPLiA - Evolution of energy consumption and energy prices",
		},
		blocks: [
			{
				type: "text",
				id: "pages.pillar.pillar1.evolutionOfEnergyConsumptionAndEnergyPrices.blocks.intro",
				data: {
					text: "pages.pillar.pillar1.evolutionOfEnergyConsumptionAndEnergyPrices.blocks.intro.paragraph",
				},
			},
			{
				type: "custom",
				id: "pages.pillar.pillar1.evolutionOfEnergyConsumptionAndEnergyPrices.blocks.visual",
				data: {
					component: EvolutionOfEnergyConsumptionAndEnergyPrices,
					props: {
						lineChartData: EvolutionOfEnergyConsumptionAndEnergyPricesLineChartData
					},
				},
			},
			{
				type: "custom",
				id: "pages.pillar.pillar1.evolutionOfEnergyConsumptionAndEnergyPrices.blocks.barchart",
				data: {
					component: EvolutionOfEnergyBarchart,
				},
			},
		],	
	},
	"navigation.pillar1.energyConsumptionAndEnergyPricesInTheEU": {
		source: {
			label: "B Lapillonne and Zineb Raji, Enerdata, Energy Efficiency Trends for Households in the EU, Odyssee MURE webinar, November 2024. www.odyssee-mure.eu/events/webinar",
		},
		pdf: {
			path: "/files/pdf/pillar-1/APPLiA-EnergyConsumptionAndEnergyPricesInTheEU.pdf",
			filename: "APPLiA - Energy consumption and energy prices in the EU",
		},
		blocks: [
			{
				type: "text",
				id: "pages.pillar.pillar1.energyConsumptionAndEnergyPricesInTheEU.blocks.intro",
				data: {
					text: "pages.pillar.pillar1.energyConsumptionAndEnergyPricesInTheEU.blocks.intro.paragraph",
				},
			},
			{
				type: "custom",
				id: "pages.pillar.pillar1.energyConsumptionAndEnergyPricesInTheEU.blocks.visual",
				data: {
					component: EnergyConsumptionAndEnergyPricesInTheEU,
				}
			}
		],	
	},
	"navigation.pillar1.averageAnnualAdditionalSavingsForEUHouseholds": {
		source: {
			label: "B Lapillonne and Zineb Raji, Enerdata, Energy Efficiency Trends for Households in the EU, Odyssee MURE webinar, November 2024. www.odyssee-mure.eu/events/webinar",
		},
		pdf: {
			path: "/files/pdf/pillar-1/APPLiA-AverageAnnualAdditionalSavingsForEUHouseholds.pdf",
			filename: "APPLiA - Average annual additional savings for EU households",
		},
		blocks: [
			{
				type: "text",
				id: "pages.pillar.pillar1.averageAnnualAdditionalSavingsForEUHouseholds.blocks.intro",
				data: {
					text: "pages.pillar.pillar1.averageAnnualAdditionalSavingsForEUHouseholds.blocks.intro.paragraph",
				},
			},
			{
				type: "custom",
				id: "pages.pillar.pillar1.averageAnnualAdditionalSavingsForEUHouseholds.blocks.visual",
				data: {
					component: AverageAnnualAdditionalSavings,
				}
			}
		],	
	},
	"navigation.pillar1.collectionOfWEEEByEUMemberStates": {
		source: {
			label: "WEEE forum",
		},
		pdf: {
			path: "/files/pdf/pillar-1/APPLiA-CollectionOfWEEEByEUMemberStates.pdf",
			filename: "APPLiA - Collection of WEEE by EU member states",
		},
		blocks: [
			{
				type: "text",
				id: "pages.pillar.pillar1.collectionOfWEEEByEUMemberStates.blocks.intro",
				data: {
					text: [
						"pages.pillar.pillar1.collectionOfWEEEByEUMemberStates.blocks.intro.paragraph1",
						"pages.pillar.pillar1.collectionOfWEEEByEUMemberStates.blocks.intro.paragraph2"
					]
				},
			},
			{
				type: "custom",
				id: "pages.pillar.pillar1.collectionOfWEEEByEUMemberStates.blocks.visual",
				data: {
					component: CollectionOfWEEEByEUMemberStates,
					props: {
						data: CollectionOfWEEEByEUMemberStatesData,
					},
				},
			},
		],	
	},
	"navigation.pillar1.hoardingOfWeee": {
		source: {
			label: "WEEE Forum data, dss+",
		},
		pdf: {
			path: "/files/pdf/pillar-1/APPLiA-HoardingOfWEEE.pdf",
			filename: "APPLiA - Hoarding of WEEE",
		},
		blocks: [
			{
				type: "text",
				id: "pages.pillar.pillar1.hoardingOfWeee.blocks.intro",
				data: {
					text: [
						"pages.pillar.pillar1.hoardingOfWeee.blocks.intro.paragraph1",
						"pages.pillar.pillar1.hoardingOfWeee.blocks.intro.paragraph2"
					]
				},
			},
			{
				type: "image",
				id: "pages.pillar.pillar1.hoardingOfWeee.blocks.visual",
				data: {
					imageSize: "big",
					imageAlignment: "center",
					imageUrl: HoardingOfWeeeVisual,
					imageAlt: "pages.pillar.pillar1.hoardingOfWeee.blocks.visual.alt",
				},
			},
			{
				type: "alert",
				id: "pages.pillar.pillar1.hoardingOfWeee.blocks.alert",
				data: {
					type: "info",
					message: "pages.pillar.pillar1.hoardingOfWeee.blocks.alert.message",
				},
			},
		],
	},
	"navigation.pillar1.weeeFlowInTheHomeApplianceSector": {
		source: {
			label:
				"dss+",
		},
		pdf: {
			path: "/files/pdf/pillar-1/APPLiA-WEEEFlowInTheHomeApplianceSector.pdf",
			filename: "APPLiA - WEEEE flow in the home appliances sector",
		},
		blocks: [
			{
				type: "text",
				id: "pages.pillar.pillar1.weeeFlowInTheHomeApplianceSector.blocks.intro",
				data: {
					text: ["pages.pillar.pillar1.weeeFlowInTheHomeApplianceSector.blocks.intro.paragraph1","pages.pillar.pillar1.weeeFlowInTheHomeApplianceSector.blocks.intro.paragraph2"],
				},
			},
			{
				type: "custom",
				id: "pages.pillar.pillar1.weeeFlowInTheHomeApplianceSector.blocks.visual",
				data: {
					component: WeeeFlowInTheHomeApplianceSector,
					props: {
						lineChartData: WeeeFlowInTheHomeApplianceSectorLineChartData
					},
				},
			},
		],
	},
	"navigation.pillar1.materialsRecoveredFromWaste": {
		source: {
			label: "dss+",
		},
		pdf: {
			path: "/files/pdf/pillar-1/APPLiA-MaterialsRecoveredFromWaste.pdf",
			filename: "APPLiA - Materials recovered from waste",
		},
		blocks: [
			{
				type: "text",
				id: "pages.pillar.pillar1.materialsRecoveredFromWaste.blocks.intro",
				data: {
					text: [
						"pages.pillar.pillar1.materialsRecoveredFromWaste.blocks.intro.paragraph1",
						"pages.pillar.pillar1.materialsRecoveredFromWaste.blocks.intro.paragraph2",
						"pages.pillar.pillar1.materialsRecoveredFromWaste.blocks.intro.paragraph3",
						"pages.pillar.pillar1.materialsRecoveredFromWaste.blocks.intro.paragraph4"
					]
				}
			},
			{
				type: "custom",
				id: "pages.pillar.pillar1.materialsRecoveredFromWaste.blocks.visual",
				data: {
					component: MaterialsRecoveredFromWaste,
				},
			},
			{
				type: "alert",
				id: "pages.pillar.pillar1.materialsRecoveredFromWaste.blocks.alert",
				data: {
					type: "info",
					message: "pages.pillar.pillar1.materialsRecoveredFromWaste.blocks.alert.message",
				},
			},
		],
	},
	/* 📝 PILLAR 2 */
	"navigation.pillar2.index": {
		heroImage: BgAcceleratingEuropesGrowth,
		heroIntro: "pages.pillar.pillar2.index.heroIntro",
		blocks: [
			{
				type: "text",
				id: "pages.pillar.pillar2.index.blocks.part1",
				data: {
					text: [
						"pages.pillar.pillar2.index.blocks.part1.paragraph1",
						"pages.pillar.pillar2.index.blocks.part1.paragraph2"
					],
				},
			},
			{
				id: "pages.pillar.pillar2.index.blocks.part2-image",
				type: "text-image",
				data: {
					text: [
						"pages.pillar.pillar2.index.blocks.part2-image.paragraph1",
						"pages.pillar.pillar2.index.blocks.part2-image.paragraph2"
					],
					imageSize: "normal",
					type: "image-left",
					imageUrl: TradePillar2,
				},
			},
			{
				type: "text",
				id: "pages.pillar.pillar2.index.blocks.part3",
				data: {
					text: [
						"pages.pillar.pillar2.index.blocks.part3.paragraph1"
					],
				},
			},
			{
				type: "text-image",
				id: "pages.pillar.pillar2.index.blocks.part4-image",
				data: {
					imageUrl: ConsumerPillar2,
					imageSize: "normal",
					type: "image-right",
					text: [
						"pages.pillar.pillar2.index.blocks.part4-image.paragraph1",
						"pages.pillar.pillar2.index.blocks.part4-image.paragraph2",
					],
				},
			},
		],
	},
	"navigation.pillar2.europeanMarketHistoricalPicture": {
		source: {
			label: "APPLiA members data",
		},
		pdf: {
			path: "/files/pdf/pillar-2/APPLiA-HistoricalEvolutionOfTheEuropeanLargeApplianceMarket.pdf",
			filename: "APPLiA - Historical evolution of the European large appliance market",
		},
		blocks: [
			{
				type: "text",
				id: "pages.pillar.pillar2.europeanMarketHistoricalPicture.blocks.intro",
				data: {
					text: "pages.pillar.pillar2.europeanMarketHistoricalPicture.blocks.intro.paragraph"
				}
			},
			{
				type: "custom",
				id: "pages.pillar.pillar2.europeanMarketHistoricalPicture.blocks.custom",
				data: {
					component: EuropeanMarketHistoricalPicture,
					props: {
						data: EuropeanMarketHistoricalPictureData,
					},
				},
			},
		],
	},
	"navigation.pillar2.largeAppliancesSoldGlobally": {
		source: {
			label: "International Roundtable of Household Appliance Manufacturer Associations (IRHMA). Product groups included in the data: Refrigerators, Freezers, Dishwashers, Tumble Dryers, Hoods, and Microwave Ovens",
		},
		pdf: {
			path: "/files/pdf/pillar-2/APPLiA-LargeAppliancesSoldGlobally.pdf",
			filename: "APPLiA - Large appliances sold globally in 2024",
		},
		blocks: [
			{
				type: "text",
				id: "pages.pillar.pillar2.largeAppliancesSoldGlobally.blocks.intro",
				data: {
					text: "pages.pillar.pillar2.largeAppliancesSoldGlobally.blocks.intro.paragraph1",
				},
			},
			{
				type: "custom",
				id: "pages.pillar.pillar2.largeAppliancesSoldGlobally.blocks.custom",
				data: {
					component: LargeAppliancesSoldGlobally,
				},
			},
		],
	},
	"navigation.pillar2.unitsTradedInEurope": {
		source: {
			label: "APPLiA members data",
		},
		pdf: {
			path: "/files/pdf/pillar-2/APPLiA-UnitsTradedInEurope.pdf",
			filename: "APPLiA - Units traded in Europe",
		},
		blocks: [
			{
				type: "text",
				id: "pages.pillar.pillar2.unitsTradedInEurope.blocks.intro",
				data: {
					text: "pages.pillar.pillar2.unitsTradedInEurope.blocks.intro.paragraph1"
				},
			},

			{
				type: "custom",
				id: "pages.pillar.pillar2.UnitsTradedInEurope.blocks.intro.visual",
				data: { component: UnitsTradedInEuropeIntro },
			},
			{
				type: "text",
				id: "pages.pillar.pillar2.unitsTradedInEurope.blocks.section1",
				data: {
					text: "pages.pillar.pillar2.unitsTradedInEurope.blocks.section1.paragraph1"
				},
			},

			{
				type: "custom",
				id: "pages.pillar.pillar2.UnitsTradedInEurope.blocks.section1.visual",
				data: { component: UnitsTradedInEuropeSection1 },
			},
			{
				type: "text",
				id: "pages.pillar.pillar2.unitsTradedInEurope.blocks.section2",
				data: {
					text: "pages.pillar.pillar2.unitsTradedInEurope.blocks.section2.paragraph1"
				},
			},

			{
				type: "custom",
				id: "pages.pillar.pillar2.UnitsTradedInEurope.blocks.section2.visual",
				data: { component: UnitsTradedInEuropeSection2 },
			},
		],
	},
	"navigation.pillar2.importAndExportOfHomeAppliancesInEuropeByContinent": {
		source: {
			label: "Eurostat COMEXT",
			url: "https://ec.europa.eu/eurostat/web/international-trade-in-goods/database",
		},
		pdf: {
			path: "/files/pdf/pillar-2/APPLiA-ImportAndExportOfHomeAppliancesInEurope.pdf",
			filename: "APPLiA - Import and export of home appliances in Europe",
		},
		blocks: [
			{
				type: "custom",
				id: "pillar-2-importAndExportOfHomeAppliancesInEuropeByContinent-chart",
				data: {
					component: ImportAndExportOfHomeAppliancesInEuropeByContinent,
					props: {
						data: fetchTradeData,
					},
				},
			},
		],
	},
	"navigation.pillar2.top10ImportAndExportCountries": {
		source: {
			label: "Eurostat COMEXT",
			url: "https://ec.europa.eu/eurostat/web/international-trade-in-goods/database",
		},
		pdf: {
			path: "/files/pdf/pillar-2/APPLiA-Top10ImportAndExportCountries.pdf",
			filename: "APPLiA - Top 10 import and export countries",
		},
		blocks: [
			{
				type: "custom",
				id: "pillar-2-top10ImportAndExportCountries",
				data: {
					component: Top10ImportAndExportCountries,
					props: {
						data: fetchCountryData,
					},
				},
			},
		],
	},
	"navigation.pillar2.evolutionOfImportAndExportOfHomeAppliancesInEurope": {
		source: {
			label: "Eurostat COMEXT",
			url: "https://ec.europa.eu/eurostat/web/international-trade-in-goods/database",
		},
		pdf: {
			path: "/files/pdf/pillar-2/APPLiA-EvolutionOfImportAndExportOfHomeAppliances.pdf",
			filename: "APPLiA - Evolution of import and export of home appliances",
		},
		blocks: [
			{
				type: "custom",
				id: "pillar-2-evolutionOfImportAndExportOfHomeAppliancesInEurope-chart",
				data: {
					component: EvolutionOfImportAndExportOfHomeAppliancesInEurope,
					props: {
						data: fetchTradeData,
					},
				},
			},
		],
	},
	"navigation.pillar2.appliaMembersManufacturingSitesInEurope": {
		source: {
			label: "APPLiA members data",
		},
		pdf: {
			path: "/files/pdf/pillar-2/APPLiA-APPLiAMembersManufacturingSitesInEurope.pdf",
			filename: "APPLiA - APPLiA members manufacturing sites in Europe in 2024",
		},
		blocks: [
			{
				type: "text",
				id: "pages.pillar.pillar2.appliaMembersManufacturingSitesInEurope.blocks.intro",
				data: {
					text: "pages.pillar.pillar2.appliaMembersManufacturingSitesInEurope.blocks.intro.paragraph1",
				},
			},
			{
				type: "custom",
				id: "pages.pillar.pillar2.appliaMembersManufacturingSitesInEurope.blocks.chart",
				data: {
					component: MembersManufacturingSites,
				},
			},
		],
	},
	"navigation.pillar2.patentsFiledAndGrantedForHomeAppliances": {
		source: {
			label: "Clarivate Analytics Derwent Innovation",
		},
		pdf: {
			path: "/files/pdf/pillar-2/APPLiA-PatentsFiledAndGrantedForHomeAppliances.pdf",
			filename: "APPLiA - Patents filed and granted for home appliances",
		},
		blocks: [
			{
				type: "text",
				id: "pages.pillar.pillar2.patentsFiledAndGrantedForHomeAppliances.blocks.intro",
				data: {
					text: "pages.pillar.pillar2.patentsFiledAndGrantedForHomeAppliances.blocks.intro.paragraph",
				},
			},
			{
				type: "custom",
				id: "pages.pillar.pillar2.patentsFiledAndGrantedForHomeAppliances.blocks.chart",
				data: {
					component: PatentsFiledAndGrantedForHomeAppliances,
					props: {
						data: PatentsFiledAndGrantedForHomeAppliancesData,
					},
				},
			},
		],
	},
	"navigation.pillar2.investmentInRAndDByEuMemberStates": {
		source: {
			label: "Eurostat (RD_E_GERDTOT) R&D related to business sector",
			url: "https://ec.europa.eu/eurostat/databrowser/view/RD_E_GERDTOT__custom_4667804/default/table?lang=en",
		},
		pdf: {
			path: "/files/pdf/pillar-2/APPLiA-InvestmentInRDByEUMemberStates.pdf",
			filename: "APPLiA - Investment in RD by EU member states",
		},
		blocks: [
			{
				type: "text",
				id: "pages.pillar.pillar2.investmentInRAndDByEuMemberStates.blocks.intro",
				data: {
					text: ["pages.pillar.pillar2.investmentInRAndDByEuMemberStates.blocks.intro.paragraph1","pages.pillar.pillar2.investmentInRAndDByEuMemberStates.blocks.intro.paragraph2"],
				},
			},
			{
				type: "custom",
				id: "pages.pillar.pillar2.investmentInRAndDByEuMemberStates.blocks.visual",
				data: {
					component: InvestmentInRAndDByEuMemberStates,
				},
			},
		],
	},
	"navigation.pillar2.investmentRDvsGDP": {
		source: {
			label: "Eurostat (RD_E_GERDTOT) R&D related to business sector",
			url: "https://ec.europa.eu/eurostat/databrowser/view/RD_E_GERDTOT__custom_4667804/default/table?lang=en",
		},
		pdf: {
			path: "/files/pdf/pillar-2/APPLiA-InvestmentInRDByEUMemberStatesAsFractionOfGDP.pdf",
			filename: "APPLiA - Investment in RD by EU member states as fraction of GDP",
		},
		blocks: [
			{
				type: "text",
				id: "pages.pillar.pillar2.investmentRDvsGDP.blocks.intro",
				data: {
					text: "pages.pillar.pillar2.investmentRDvsGDP.blocks.intro.paragraph1"
				}
			},
			{
				type: "custom",
				id: "pages.pillar.pillar2.investmentRDvsGDP.blocks.visual",
				data: {
					component: InvestmentRDvsGDP,
					props: {
						data: InvestmentRDvsGDPData,
					},
				},
			},
		],
	},
};
